import React from 'react'
import OfflinePinIcon from '@material-ui/icons/OfflinePin'

export const PrefetchSuccessIcon = props => (
  <OfflinePinIcon color="primary" fontSize="small" {...props} />
)

export default PrefetchSuccessIcon
